// @ts-nocheck --> Dangerous, must be removed
import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import styled, { createGlobalStyle } from 'styled-components'
import qs from 'query-string'
import 'intersection-observer'
import Router, { withRouter } from 'next/router'

import {
  requestCatalog,
  loadMoreCatalog,
  resetCatalogModule,
  setQueryParams,
  setCityFilters,
  initSortBy,
  setIsLoading,
  requestFilters,
  setCurrentShowTab,
  setChangingSort
} from '@stores/catalog'
import ButtonWithCloseIcon from '@components/ButtonWithCloseIcon'
import { logger, getCatalogFiltersRouteParams, shallowCompare } from '@utils'
import cssClasses from '@constants/cssClasses'
import alphabeticSelect from '@constants/alphabeticSelect'
import { catalogEntityUrl } from '@constants/catalog'
import { filterEntityTypes } from '@constants/entityTypes'
import { catalogUrls } from '@constants/url'
import FullScreenLoader from '@components/FullScreenLoader'
import ApiResponseError from '@components/ApiResponseError'
import Text from '@components/Text'
import EntityGrid from './EntityGrid'
import LocationFilterList from './LocationFilterList'
import SectorMediumFilterList from './SectorMediumFilterList'
import YearCreatedFilterList from './YearCreatedFilterList'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { Col, Container, Dropdown, Row, Spinner } from '@mch-group/uikit-components'

// Global styles for catalog pages to hide any modules in this page other than CTL and CLA when a specific show
// has been selected.
const CatalogGlobalStyle = createGlobalStyle`
  .site-modules.catalog--specific-show {
    > *:not([class*="ModuleList"]):not([class*="CatalogListTitle"]) {
      display: none !important;
    }
  }
`

const mID = 'otm-catalog-list'

const buildSelectSort = (props) => {
  const values = []
  if (props.cal_grp1_sort_option1) {
    values.push({
      label: props.cal_grp1_sort_option1,
      value: 'random'
    })
  }
  if (props.cal_grp1_sort_option2) {
    values.push({
      label: props.cal_grp1_sort_option2,
      value: 'sortingName'
    })
  }
  return values
}

class OtmCatalogList extends Component {
  static propTypes = {
    className: PropTypes.string,
    catalog: PropTypes.object,
    requestCatalog: PropTypes.func,
    loadMoreCatalog: PropTypes.func,
    resetCatalogModule: PropTypes.func,
    setQueryParams: PropTypes.func,
    setCityFilters: PropTypes.func,
    initSortBy: PropTypes.func,
    setIsLoading: PropTypes.func,
    requestFilters: PropTypes.func,
    setCurrentShowTab: PropTypes.func,
    setChangingSort: PropTypes.func,
    user: PropTypes.object,
    labels: PropTypes.object,
    query: PropTypes.object,
    router: PropTypes.object,
    cal_grp1_filter_option1: PropTypes.string,
    cal_grp1_filter_option2: PropTypes.string,
    cal_grp1_filter_option3: PropTypes.string,
    cal_grp1_not_found: PropTypes.string,
    cal_grp1_count_label: PropTypes.string,
    cal_grp1_jump_to_label: PropTypes.string,
    cal_grp1_sort_option1: PropTypes.string,
    cal_grp1_sort_option2: PropTypes.string,
    cal_grp1_sort_label: PropTypes.string,
    cal_grp1_filter_label: PropTypes.string,
    cal_grp1_reset_filters: PropTypes.string,
    cal_grp1_filter_option4: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.handleSort = this.handleSort.bind(this)
    this.handleJumpTo = this.handleJumpTo.bind(this)
    this.entityGridRef = createRef()
    this.alreadyScrolledToFavorite = true
  }

  state = {
    isLoading: true,
    offset: 0,
    hasMore: false,
    selectedLocationId: 'all',
    selectedShowId: 'all',
    selectedSectorId: 'all',
    selectedMediumId: 'all',
    selectedCreatedYearId: 'all'
  }

  async componentDidMount() {
    this.setupObserver()
    this.defaultParams = qs.parse(window.location.search)
    this.props.query.slug = this.props.query.slug ? this.props.query.slug.split('?')[0] : window.location.pathname
    if (!this.props.user.me && 'access' in this.defaultParams) {
      delete this.defaultParams.access
    }
    if (this.props.user.me && this.defaultParams.favorite === 'true') {
      this.defaultParams.favorite = true
      this.alreadyScrolledToFavorite = false
    } else if (!this.props.user.me && this.defaultParams.favorite) {
      delete this.defaultParams.favorite
    }
    await this.props.initSortBy(this.props.query.slug)
    const queryParams = { ...this.props.catalog.defaultParams, ...this.defaultParams }
    await this.props.setQueryParams(queryParams)
    await this.getCatalog(queryParams)
    if (this.defaultParams.showIds && this.defaultParams.showIds.split(',').length === 1) {
      this.setState({
        selectedShowId: this.defaultParams.showIds
      })
    }
    if (this.defaultParams.sectorIds && this.defaultParams.sectorIds.split(',').length === 1) {
      this.setState({
        selectedSectorId: this.defaultParams.sectorIds
      })
    }
    if (this.defaultParams.medium && this.defaultParams.medium.split(',').length === 1) {
      this.setState({
        selectedMediumId: this.defaultParams.medium
      })
    }
    if (this.defaultParams.locations && this.defaultParams.locations.split(',').length === 1) {
      this.setState({
        selectedLocationId: this.defaultParams.locations
      })
    }
    if (this.defaultParams.startYear && this.defaultParams.endYear) {
      this.setState({
        selectedCreatedYearId: `startYear=${this.defaultParams.startYear}&endYear=${this.defaultParams.endYear}`
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { state, props } = this
    if (
      props !== nextProps ||
      state.offset !== nextState.offset ||
      state.hasMore !== nextState.hasMore ||
      state.isLoading !== nextState.isLoading ||
      props.catalog.currentParams.sortBy !== nextProps.catalog.currentParams.sortBy ||
      props.catalog.currentParams.atozLetter !== nextProps.catalog.currentParams.atozLetter ||
      props.catalog.currentParams.showIds !== nextProps.catalog.currentParams.showIds ||
      props.catalog.currentParams.sectorIds !== nextProps.catalog.currentParams.sectorIds ||
      props.catalog.currentParams.locations !== nextProps.catalog.currentParams.locations ||
      props.catalog.currentParams.favorite !== nextProps.catalog.currentParams.favorite ||
      props.catalog.currentParams.startYear !== nextProps.catalog.currentParams.startYear ||
      props.catalog.currentParams.endYear !== nextProps.catalog.currentParams.endYear
    ) {
      return true
    }
    return false
  }

  async componentDidUpdate(prevProps) {
    const { query } = this.props.router
    const { query: prevQuery } = prevProps.router

    // Manage classes to hide any modules in this page other than CTL and CLA when a specific show has been selected.
    if (query.showIds) {
      document.querySelector('.site-modules').classList.add('catalog--specific-show')
    } else {
      document.querySelector('.site-modules').classList.remove('catalog--specific-show')
    }

    // Compare previous router query parameters to the new one on component update.
    // Fetch new catalog items depending on those parameters which are coming as a result of router changes
    // that are triggered by filtering of catalog.
    if (!shallowCompare(prevQuery, query)) {
      // Remove slug from the query parameters since they're irrelevant to the filters.
      const { ...rest } = query
      // Set current show tab (secondary menu) to "All Shows" if there's no showIds parameter
      !rest.showIds && (await this.props.setCurrentShowTab(''))
      // Set alreadyScrolledToFavorite back to false if favorite has been enabled or disabled
      if ((!prevQuery.favorite && query.favorite) || (prevQuery.favorite && !query.favorite)) {
        this.alreadyScrolledToFavorite = false
      }

      // At some point, the values are being set as '' instead of undefined
      // This foreach turns all '' into undefined.
      // This is necessary "at least" to have the "reset filters" working fine.
      const restCopy = { ...rest }
      Object.keys(restCopy).forEach(function (e) {
        restCopy[e] = restCopy[e] !== '' ? restCopy[e] : undefined
      })
      // Send new filter parameters to Redux and load new items
      await this.props.setQueryParams(restCopy, true)
      await this.getCatalog(restCopy)
      await this.props.setChangingSort(false)
    }
  }

  componentWillUnmount() {
    this.observer.disconnect()
    this.props.resetCatalogModule()
  }

  onCitiesLoaded = (cities) => {
    this.props.setCityFilters(cities)
  }

  setupObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 1500px 0px',
      threshold: 0
    }
    this.observer = new IntersectionObserver(this.handleObserver.bind(this), options)
  }

  getLocationsColumns(catalog) {
    return catalog.currentParams.showIds ? 3 : 6
  }

  async getCatalog(defaultParams = {}) {
    try {
      this.setState({ isLoading: true })
      this.props.setIsLoading(true)
      const queryData = this.props.query.slug || this.props.router.asPath
      const response = await this.props.requestCatalog(queryData, defaultParams)
      this.props.setIsLoading(false)
      this.setState(
        {
          isLoading: false,
          offset: this.state.offset,
          hasMore: response?.payload?.hasMore || false
        },
        () => {
          if (this.state.hasMore) {
            this.loadingRef && this.observer.observe(this.loadingRef)
          } else {
            this.loadingRef && this.observer.unobserve(this.loadingRef)
          }
          // Scroll EntityGrid into view if favorite filter has been enabled/disabled
          this.scrollGridIntoView()
        }
      )
    } catch (e) {
      logger(e)
    }
  }

  getFilterDataByEntityType(catalog, entityType) {
    const dataEntity = !catalog.currentParams.artworkForSale
      && catalog?.filters?.length && catalog.filters.find(entity => entity.entityType === entityType)
    if (dataEntity) {
      if (entityType === filterEntityTypes.show && catalog.currentParams.showIds) {
        const firstShow = catalog.currentParams.showIds.split(',')[0]
        const currentShow = dataEntity.options.find(entity => entity.showIds.split(',').includes(firstShow))
        if (currentShow) {
          return currentShow.options
        }
        return []
      }
      return dataEntity.options
    }
    return []
  }

  getFilterDataByEntityTypeForMobile(catalog, entityType) {
    const dataList = this.getFilterDataByEntityType(catalog, entityType)
    const allData = [{ text: 'All', value: 'all' }]
    const dataMapped = dataList.map((data) => {
      const newData = {}
      newData.label = data.value
      newData.value = data.code
      return newData
    })
    Array.prototype.push.apply(allData, dataMapped)
    return allData
  }

  getLocationsForMobile(catalog) {
    const allLocations = [{ label: 'All', value: 'all' }]
    const locationsMapped = catalog.cityFilters.map((l) => {
      const location = {}
      location.label = l.name
      location.value = `${l.latitude}:${l.longitude}:${l.radius}`
      return location
    })
    Array.prototype.push.apply(allLocations, locationsMapped)
    return allLocations
  }

  getCreatedYearList() {
    const yearCreated = [
      { 'code': `startYear=2001&endYear=${new Date().getFullYear()}`, 'value': '2001 - today' },
      { 'code': 'startYear=1976&endYear=2000', 'value': '1976 - 2000' },
      { 'code': 'startYear=1951&endYear=1975', 'value': '1951 - 1975' },
      { 'code': 'startYear=1926&endYear=1950', 'value': '1926 - 1950' },
      { 'code': 'startYear=1900&endYear=1925', 'value': '1900 - 1925' }
    ]
    return yearCreated
  }

  getCreatedYearListForMobile() {
    const yearCreated = [
      { value: 'all', label: 'All' },
      { value: `startYear=2001&endYear=${new Date().getFullYear()}`, label: '2001 - today' },
      { value: 'startYear=1976&endYear=2000', label: '1976 - 2000' },
      { value: 'startYear=1951&endYear=1975', label: '1951 - 1975' },
      { value: 'startYear=1926&endYear=1950', label: '1926 - 1950' },
      { value: 'startYear=1900&endYear=1925', label: '1900 - 1925' }
    ]
    return yearCreated
  }

  scrollGridIntoView() {
    if (this.entityGridRef.current && !this.alreadyScrolledToFavorite) {
      this.alreadyScrolledToFavorite = true
      this.entityGridRef.current.scrollIntoView()
    }
  }

  handleLoadingRef(loadingRef) {
    this.loadingRef = loadingRef
  }

  handleObserver(entities) {
    const { isIntersecting } = entities[0]
    if (isIntersecting) {
      this.requestNewPage()
    }
  }

  async requestNewPage() {
    if (this.props.catalog.catalogData?.hasMore && !this.state.isLoading && !this.props.catalog.isChangingSort) {
      this.setState(
        {
          offset: this.state.offset + 36
        },
        await this.updateList
      )
    }
  }

  handleHasMoreCatalog() {
    const hasMore = this.props.catalog.catalogData?.hasMore
    if (hasMore) {
      this.loadingRef && this.observer.observe(this.loadingRef)
    } else {
      this.loadingRef && this.observer.unobserve(this.loadingRef)
    }
  }

  async updateList() {
    try {
      // this.setupObserver()
      const items = this.props.catalog.catalogData
      this.setState({ isLoading: true })
      const queryData = this.props.query.slug || this.props.router.asPath
      await this.props.loadMoreCatalog(queryData, items)
      this.handleHasMoreCatalog()
      this.setState({
        isLoading: false,
        offset: this.state.offset,
        hasMore: this.props?.catalog?.catalogData?.hasMore || false
      })
    } catch (e) {
      logger(e)
    }
  }

  async updateQueryParamsMultipleValues(values) {
    let valueChanged = false
    const newValues = {}
    values.forEach((element) => {
      if (this.props.catalog.currentParams[element.name] !== element.value) {
        newValues[element.name] = element.value
        valueChanged = true
      }
    })
    if (valueChanged) {
      await this.props.setQueryParams({ ...this.props.catalog.currentParams, ...newValues })
      const params = {
        showIds: this.props.catalog.currentParams.showIds,
        locations: this.props.catalog.currentParams.locations,
        sectorIds: this.props.catalog.currentParams.sectorIds,
        medium: this.props.catalog.currentParams.medium,
        startYear: this.props.catalog.currentParams.startYear,
        endYear: this.props.catalog.currentParams.endYear,
        favorite: this.props.catalog.currentParams.favorite || undefined,
        sortBy: this.props.catalog.currentParams.sortBy,
        atozLetter: this.props.catalog.currentParams.atozLetter
      }

      this.setState(state => ({
        ...state,
        offset: 0
      }), () => {
        const queryData = this.props.query.slug || this.props.router.asPath
        const [href, as] = getCatalogFiltersRouteParams(queryData, params)
        Router.push(href, as, { shallow: true })
      })
    }
  }

  async resetValues() {
    const newValues = {}
    await this.props.setQueryParams({ ...newValues })
    const params = {}

    this.setState(state => ({
      ...state,
      offset: 0
    }), () => {
      const queryData = this.props.query.slug || this.props.router.asPath
      const [href, as] = getCatalogFiltersRouteParams(queryData, params)
      Router.push(href, as, { shallow: true })
    })
  }

  async updateQueryParams(name, value) {
    if (this.props.catalog.currentParams[name] !== value) {
      const queryParams = { ...this.props.catalog.currentParams, [name]: value }
      if (name === 'showIds') {
        const queryData = this.props.query.slug || this.props.router.asPath
        await this.props.requestFilters(queryData, queryParams)
        // check if the previous sectorIds selected are still in the list of sectors
        const dataEntity = this.props.catalog.filters.find(entity => entity.entityType === filterEntityTypes.sector)
        if (dataEntity) {
          let currentSectors = []
          const sectorsStillDisplay = []
          currentSectors = this.props.catalog.currentParams.sectorIds ?
            this.props.catalog.currentParams.sectorIds.split(',') : []
          // eslint-disable-next-line no-loops/no-loops
          for (let i = 0; i < currentSectors.length; i++) {
            const sectorId = currentSectors[i]
            if (dataEntity.options.find(option => option.code === sectorId)) {
              sectorsStillDisplay.push(sectorId)
            }
          }
          queryParams.sectorIds = sectorsStillDisplay.join(',')
          if (!queryParams.sectorIds) {
            queryParams.sectorIds = undefined
          }
        }
      }
      if (name === 'sortBy') {
        await this.props.setChangingSort(true)
      }
      await this.props.setQueryParams(queryParams)
      const params = {
        showIds: this.props.catalog.currentParams.showIds,
        locations: this.props.catalog.currentParams.locations,
        sectorIds: this.props.catalog.currentParams.sectorIds,
        medium: this.props.catalog.currentParams.medium,
        startYear: this.props.catalog.currentParams.startYear,
        endYear: this.props.catalog.currentParams.endYear,
        favorite: this.props.catalog.currentParams.favorite || undefined,
        sortBy: this.props.catalog.currentParams.sortBy,
        atozLetter:
          this.props.catalog.currentParams.sortBy === 'random' ? undefined : this.props.catalog.currentParams.atozLetter
      }

      this.setState(state => ({
        ...state,
        offset: 0
      }), () => {
        const queryData = this.props.query.slug || this.props.router.asPath
        const [href, as] = getCatalogFiltersRouteParams(queryData, params)
        Router.push(href, as, { shallow: true })
      })
    }
  }

  handleSort = async (event) => {
    await this.updateQueryParams('sortBy', event)
  }

  handleJumpTo = async (event) => {
    await this.updateQueryParams('atozLetter', event)
  }

  locationsChanged = async (locations) => {
    await this.updateQueryParams('locations', locations || undefined)
  }

  locationsChangedMobile = (event) => {
    let locationValue = event
    if (event === 'all') {
      locationValue = ''
    }
    this.updateQueryParams('locations', locationValue || undefined)
    this.setState({
      selectedLocationId: event
    })
  }

  showChanged = async (shows) => {
    await this.updateQueryParams('showIds', shows || undefined)
  }

  showChangedMobile = (event, show) => {
    let showValue = show.value
    if (show.value === 'all') {
      showValue = this.props.catalog.currentShowTab
    }
    this.updateQueryParams('showIds', showValue || undefined)
    this.setState({
      selectedShowId: show.value
    })
  }

  sectorChanged = async (sectors) => {
    await this.updateQueryParams('sectorIds', sectors || undefined)
  }

  sectorChangedMobile = (event) => {
    let sectorValue = event
    if (event === 'all') {
      sectorValue = ''
    }
    this.updateQueryParams('sectorIds', sectorValue || undefined)
    this.setState({
      selectedSectorId: event
    })
  }

  mediumChanged = async (medium) => {
    await this.updateQueryParams('medium', medium || undefined)
  }

  mediumChangedMobile = (event) => {
    let mediumValue = event
    if (event === 'all') {
      mediumValue = ''
    }
    this.updateQueryParams('medium', mediumValue || undefined)
    this.setState({
      selectedMediumId: event
    })
  }

  yearCreatedChanged = async (values) => {
    await this.updateQueryParamsMultipleValues(values)
  }

  yearCreatedChangedForMobile = (event) => {
    let yearValue = event
    if (event === 'all') {
      yearValue = ''
    }
    let values = [
      { name: 'startYear', value: undefined },
      { name: 'endYear', value: undefined }
    ]
    if (yearValue) {
      const parsedCode = qs.parse(event)
      values = [
        { name: 'startYear', value: parsedCode.startYear },
        { name: 'endYear', value: parsedCode.endYear }
      ]
    }
    this.updateQueryParamsMultipleValues(values)
    this.setState({
      selectedCreatedYearId: event
    })
  }

  isAllShowYearSelected = () => {
    const { props } = this
    const currentAllShowIds = this.getFilterDataByEntityTypeForMobile(props.catalog, filterEntityTypes.show).length - 1
    const currentShowIds = props.catalog.currentParams.showIds
    let currentSelectedShows = 0
    if (currentShowIds) {
      currentSelectedShows = currentShowIds.split(',').length
    }
    return currentSelectedShows === currentAllShowIds
  }



  render() {
    const { props, state } = this
    const showResetFiltersButton =
      typeof props.catalog.currentParams.showIds !== 'undefined' ||
      typeof props.catalog.currentParams.locations !== 'undefined' ||
      typeof props.catalog.currentParams.medium !== 'undefined' ||
      props.catalog.currentParams.startYear ||
      props.catalog.currentParams.atozLetter !== 'all'

    // Note: set the slug value if it is coming from email because we are getting empty query object from email redirection
    // It will fix the artists, artworks and galleries redirection issue from email as well
    if (Object.keys(props.query).length === 0) {
      props.query.slug = props.router.asPath
    }

    if (props.catalog.catalogData === 'error') {
      return <ApiResponseError className={props.className} mID={mID} />
    }

    if (!props.catalog.catalogData) {
      return <FullScreenLoader className={props.className} active />
    }

    return (
      <section className={classNames(props.className, cssClasses.CMS_MODULE)}>
        {showResetFiltersButton &&
          <ContainerStyled className='px-5 px-lg-8 px-md-7'>
            <Row>
              <Col className='tablet hidden mobile hidden d-flex justify-content-end'>
                <ButtonWithCloseIcon
                  onClick={() => {
                    this.resetValues()
                  }}
                  label={props.cal_grp1_reset_filters || 'Reset all filters'}
                />
              </Col>
            </Row>
          </ContainerStyled>}
        <Container className={`${mID} px-5 px-lg-8 px-md-7`}>
          <>
            <Row className={`${mID}__separator`}>
              {this.getFilterDataByEntityType(props.catalog, filterEntityTypes.sector).length > 0 &&
                props.catalog.currentParams.showIds &&
                (catalogUrls.includes(props.query.slug)) && (
                  <>
                    <Col md={5}>
                      <SectorMediumFilterList
                        selects={props.catalog.currentParams.sectorIds}
                        selectsChanged={this.sectorChanged}
                        columns={2}
                        title={props.cal_grp1_filter_option2}
                        data={this.getFilterDataByEntityType(props.catalog, filterEntityTypes.sector)}
                      />
                    </Col>
                  </>
                )}
              {(props.query.slug === catalogEntityUrl.galleries) && (
                <Col md={props.catalog.currentParams.showIds ? 7 : 12}>
                  <LocationFilterList
                    selects={props.catalog.currentParams.locations}
                    selectsChanged={this.locationsChanged}
                    columns={this.getLocationsColumns(props.catalog)}
                    title={props.cal_grp1_filter_option3}
                    citiesLoaded={this.onCitiesLoaded}
                  />
                </Col>
              )}
              {(props.query.slug === catalogEntityUrl.artists || props.query.slug === catalogEntityUrl.artworks) && (
                <Col md={4}>
                  <SectorMediumFilterList
                    selects={props.catalog.currentParams.medium}
                    selectsChanged={this.mediumChanged}
                    columns={2}
                    title={props.cal_grp1_filter_option3}
                    data={this.getFilterDataByEntityType(props.catalog, filterEntityTypes.medium)}
                  />
                </Col>
              )}
              {props.query.artworkForSale &&
                <Col md={4}>
                  <SectorMediumFilterList
                    selects={props.catalog.currentParams.medium}
                    selectsChanged={this.mediumChanged}
                    columns={2}
                    title={props.cal_grp1_filter_option3}
                    data={this.getFilterDataByEntityType(props.catalog, 'MP_MEDIUM')}
                  />
                </Col>
              }
              {props.query.slug === catalogEntityUrl.artworks && (
                <Col md={2}>
                  <YearCreatedFilterList
                    startYear={props.catalog.currentParams.startYear}
                    endYear={props.catalog.currentParams.endYear}
                    selectsChanged={this.yearCreatedChanged}
                    columns={1}
                    title={props.cal_grp1_filter_option4}
                    data={this.getCreatedYearList()}
                  />
                </Col>
              )}
            </Row>
          </>
          <form className={`${mID}__form`}>
            <Row>
              <Col md={3}>
                <Dropdown
                  label={props.cal_grp1_sort_label}
                  value={props.catalog.currentParams.sortBy}
                  options={buildSelectSort(props)}
                  onChange={this.handleSort}
                  aria-label={props.cal_grp1_sort_label}
                />
              </Col>
              {props.catalog.currentParams.sortBy === 'sortingName' && (
                <Col md={3}>
                  <Dropdown
                    label={props.cal_grp1_jump_to_label}
                    value={props.catalog.currentParams.atozLetter}
                    options={alphabeticSelect}
                    onChange={this.handleJumpTo}
                    aria-label={props.cal_grp1_jump_to_label}
                  />
                </Col>
              )}
              <Col>
                <Text className='d-flex justify-content-end'>
                  {`${props.catalog.catalogData.total} ${props.cal_grp1_count_label}`}
                </Text>
              </Col>
            </Row>
          </form>
          <form className={`${mID}__mobile-form`}>
            {
              props.catalog.currentParams.showIds && (catalogUrls.includes(props.query.slug)) && (
                <Row className='m-0 mb-5'>
                  <Col>
                    <Dropdown
                      label={<p><b>{props.cal_grp1_filter_option2}</b></p>}
                      value={props.catalog.currentParams.sectorIds || 'all'}
                      options={this.getFilterDataByEntityTypeForMobile(props.catalog, filterEntityTypes.sector)}
                      onChange={this.sectorChangedMobile}
                      aria-label={props.cal_grp1_filter_option2}
                    />
                  </Col>
                </Row>
              )}
            {(props.query.slug === catalogEntityUrl.galleries)
              && (
                <Row className='m-0 mb-5'>
                  <Col>
                    <Dropdown
                      label={<p><b>{props.cal_grp1_filter_option3}</b></p>}
                      value={state.selectedLocationId || 'all'}
                      options={this.getLocationsForMobile(props.catalog)}
                      onChange={this.locationsChangedMobile}
                      aria-label={props.cal_grp1_filter_option3}
                    />
                  </Col>
                </Row>
              )}
            {(props.query.slug === catalogEntityUrl.artists || props.query.slug === catalogEntityUrl.artworks) && (
              <Row className='m-0 mb-5'>
                <Col>
                  <Dropdown
                    label={<p><b>{props.cal_grp1_filter_option3}</b></p>}
                    value={props.catalog.currentParams.medium || 'all'}
                    options={this.getFilterDataByEntityTypeForMobile(props.catalog, filterEntityTypes.medium)}
                    onChange={this.mediumChangedMobile}
                    aria-label={props.cal_grp1_filter_option3}
                  />
                </Col>
              </Row>
            )}
            {props.query.slug === catalogEntityUrl.artworks && (
              <Row className='m-0 mb-5'>
                <Col>
                  <Dropdown
                    label={<p><b>{props.cal_grp1_filter_option4}</b></p>}
                    value={
                      (props.catalog.currentParams.startYear && props.catalog.currentParams.endYear) ?
                        `startYear=${props.catalog.currentParams.startYear
                        }&endYear=${props.catalog.currentParams.endYear
                        }` :
                        'all'
                    }
                    options={this.getCreatedYearListForMobile()}
                    onChange={this.yearCreatedChangedForMobile}
                    aria-label={props.cal_grp1_filter_option4}
                  />
                </Col>
              </Row>
            )}
            <Row className='m-0 mb-5'>
              <Col>
                <Dropdown
                  label={<p><b>{props.cal_grp1_sort_label}</b></p>}
                  value={props.catalog.currentParams.sortBy}
                  options={buildSelectSort(props)}
                  onChange={this.handleSort}
                  aria-label={props.cal_grp1_sort_label}
                />
              </Col>
            </Row>
            {props.catalog.currentParams.sortBy === 'sortingName' && (
              <Row className='m-0 mb-5'>
                <Col>
                  <Dropdown
                    label={<p><b>{props.cal_grp1_jump_to_label}</b></p>}
                    value={props.catalog.currentParams.atozLetter}
                    options={alphabeticSelect}
                    onChange={this.handleJumpTo}
                    aria-label={props.cal_grp1_jump_to_label}
                  />
                </Col>
              </Row>
            )}
          </form>
          {showResetFiltersButton &&
            <>
              <br />
              <Col computer={12} className='tablet only mobile only'>
                <ButtonWithCloseIcon
                  onClick={() => {
                    this.resetValues()
                  }}
                  label='Reset all filters'
                />
              </Col>
            </>}
          {props.catalog.isLoading && <Spinner theme='light' variant='page' />}
          <EntityGrid
            className={mID}
            sortBy={props.catalog.currentParams.sortBy}
            entities={props.catalog}
            notFoundLabel={props.cal_grp1_not_found}
            query={props.query}
            hide={props.catalog.isChangingSort}
            ref={this.entityGridRef}
            labels={this.props.labels}
          />

          {props.catalog.catalogData.hasMore && state.isLoading && !props.catalog.isChangingSort && (
            <Container className='px-5 px-lg-8 px-md-7'>
              <div>
                <Spinner variant='button' theme='secondary' />
              </div>
            </Container>
          )}
        </Container>
        <div
          ref={loadingRef => this.handleLoadingRef(loadingRef)}
          // Edge needs the observed item to have some width and height
          style={{ height: '1px', width: '1px' }}
        />
        <FullScreenLoader active={state.isLoading && props.catalog.catalogData === null} />
        <CatalogGlobalStyle />
      </section>
    )
  }
}

const ConnectedOtmCatalogList = connect(
  ({ user, catalog, page }) => ({
    user,
    catalog,
    query: page.query
  }),
  {
    requestCatalog,
    loadMoreCatalog,
    resetCatalogModule,
    setQueryParams,
    setCityFilters,
    initSortBy,
    setIsLoading,
    requestFilters,
    setCurrentShowTab,
    setChangingSort
  }
)(withRouter(OtmCatalogList))

const ContainerStyled = styled(Container)`
  position: relative;
  top: -60px;
  height: 0;

  > div {
    > button {
      margin-left: auto;
      display: block;
    }
  }
`

export default styled(ConnectedOtmCatalogList)`
  .${mID} {
    &__separator {
      border-bottom: 0.5px solid ${tokens.color.light.base.neutrals[200].value};

      @media (max-width: 991px) {
        display: none !important;
      }
    }

    &__mobile-form {
      @media (max-width: 991px) {
        width: 100%;
      }

      @media (min-width: 992px) {
        display: none !important;
      }
    }

    &__form {
      @media (max-width: 991px) {
        display: none !important;
      }

      @media (min-width: 992px) {
        margin-top: 40px;
      }
    }
  }
`